import React, { useCallback, useMemo } from 'react';
import Searcher from './Searcher';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import { adaptSeguimientosFKArray, GET_SEGUIMIENTOS_FK_PAGINATED_RECLAMOS } from '../../../../../../data/graphQL/queries/Reclamos/getAllSeguimientoFK';

const SeguimientoFKField = ({
    onChange,
    idSeguimientoFK,
    disabled,
}) => {

    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);

    const getSearchParams = useCallback((textValue) => {

        const searchParams = textValue ? {
            or: [
                { codReclamo: { contains: textValue } },
                { descripcion: { contains: textValue } },
                { paciente: { contains: textValue } },
                { producto: { contains: textValue } }
            ]
        } : {};

        return searchParams;
    }, []);

    const handleRowClick = (row) => {
        onChange('idSeguimientoFK', row?.codReclamo);
    }

    const getEntityValue = (row) => {
        const value = !!row ? `${row.codReclamo}` : null;

        return value;
    }

    return <Searcher
        displayName='Seguimiento FK'
        titleModal='Seleccionar Reclamo'
        entityName='reclamosSDR'
        entityId='codReclamo'
        entityIdValue={idSeguimientoFK}
        columns={CONFIGURATED_COLUMNS}
        query={GET_SEGUIMIENTOS_FK_PAGINATED_RECLAMOS}
        adapter={adaptSeguimientosFKArray}
        getSearchParams={getSearchParams}
        onRowClick={handleRowClick}
        getEntityValue={getEntityValue}
        disabled={disabled}
    />
}

export default SeguimientoFKField;

const columns = [
    {
        field: 'codReclamo',
        headerName: 'Cod. Reclamo',
        flex: 1
    },
    {
        field: 'descripcion',
        headerName: 'Descripción',
        flex: 1.5
    },
    {
        field: 'paciente',
        headerName: 'Paciente',
        flex: 1,
    },
    {
        field: 'fechaOcurrencia',
        headerName: 'F. de Ocurrencia',
        type: 'date',
        flex: 1
    },
    {
        field: 'producto',
        headerName: 'Producto',
        flex: 1,
    },
];